import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Loader,
  LoadingOverlay,
  Menu,
  Select,
  Table,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import {
  IconBarcode,
  IconCheck,
  IconEdit,
  IconSearch,
  IconTrash,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../_base/_const/_constVar";
import { paginationBase } from "../../_base/model/_base/BaseTable";
import { _localization } from "../../config/location";
import { green } from "../../const/variables";
import { MessageResponse } from "../../model/MessageResponse";
import { UpdateStatusDetails } from "./ModalUpdateTestingTechnique";
import { useDisclosure } from "@mantine/hooks";

interface dataProduct {
  id: number;
  description: string;
  itemId: number;
  itemCode: string;
  itemName: string;
  actribute4: string;
  actribute5: number;
  serialCode: string;
  notInSystem?: boolean;
}

const ListProductDetail = ({
  typeSourceType,
  dataDetail,
  isDetail,
  isAssign,
  form,
  height,
  datatestDifficultys,
  testingStatus,
  listProductTest,
  setListProductTest,
  branchCode,
  isReadOnlyTestDifficulty,
  showBhmr,
}: {
  typeSourceType?: string;
  dataDetail?: any;
  isDetail: boolean;
  isAssign?: any;
  form?: UseFormReturnType<
    UpdateStatusDetails,
    (values: UpdateStatusDetails) => UpdateStatusDetails
  >;
  height?: number;
  datatestDifficultys?: any;
  testingStatus?: any;
  listProductTest?: any;
  setListProductTest?: any;
  branchCode?: string;
  isReadOnlyTestDifficulty?: boolean;
  /** Hiện cột "Gói BHMR" (goiBhmr của get-detail-v2); màn Cập nhật và Xem chi tiết KTKT bật */
  showBhmr?: boolean;
}) => {
  const [isEditStatus, setIsEditStatus] = useState(true);
  //data and fetching state
  const [data] = useState<any[]>([dataDetail]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState(paginationBase);
  //table state
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  //count
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);

  const [listSerial, setListSerial] = useState<string>("");
  const [dataEdit, setDataEdit] = useState<dataProduct>({
    id: 0,
    description: "",
    itemId: 0,
    itemCode: "",
    itemName: "",
    actribute4: "",
    actribute5: 0,
    serialCode: "",
  });
  const [rowSelect, setRowSelect] = useState<number>(-1);
  const [visible, { toggle, open, close }] = useDisclosure(false);
  const [dataProductMap, setDataProductMap] = useState<any[]>([]);

  const testingStatuss = React.useMemo(
    () => [
      {
        label: "Test ok",
        value: "TEST_OK",
      },
      {
        label: "Test lỗi",
        value: "TEST_LOI",
      },
    ],
    [],
  );

  const [testDifficultys, setTestDifficultys] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
      },

      {
        accessorKey: "serial",
        header: "Số serial",
      },
      ...(showBhmr
        ? [
            {
              // Gói BHMR đang hiệu lực của serial, API ghép sẵn chữ
              accessorKey: "goiBhmr",
              header: "Gói BHMR",
              size: 300,
              Cell: ({ renderedCellValue }: any) =>
                renderedCellValue ? (
                  <Tooltip label={renderedCellValue} withArrow multiline w={400}>
                    <Text lineClamp={1} fz="inherit">
                      {renderedCellValue}
                    </Text>
                  </Tooltip>
                ) : null,
            },
          ]
        : []),
      {
        accessorKey: "uomName",
        header: "Đơn vị tính",
      },
      {
        accessorKey: "quality",
        header: "Số lượng",
      },
      ...(typeSourceType == "DON_HANG"
        ? [
            {
              accessorKey: "lineTyle",
              header: "Loại mặt hàng", // Tiêu đề hiển thị
            },
          ]
        : []),
      ...(typeSourceType == "CHUYEN_DOI_DU_LIEU"
        ? [
            {
              accessorKey: "invPositionName",
              header: "Vị trí trong kho", // Tiêu đề hiển thị
            },
          ]
        : []),
      {
        accessorKey: "testingStatus",
        header: "Trạng thái kiểm tra",
        Cell: ({ renderedCellValue, row }) =>
          form ? (
            <Select
              clearable
              searchable
              disabled={
                // row.original.canUpdate === false || // Nếu canUpdate là false, không cho chỉnh sửa
                row.original.testingStatus === "TEST_OK" && isEditStatus // Điều kiện disable cũ
                  ? true
                  : false
              }
              // placeholder="Chọn mức độ"
              data={testingStatuss}
              value={form
                ?.getValues()
                ?.updateStatusTblTestingTechniqueHeaderDetailCommandModels?.find(
                  (d) => d.id === row.original?.id,
                )
                ?.testingStatus?.toString()}
              onChange={(value) =>
                form.setValues((prev) => ({
                  ...prev,
                  updateStatusTblTestingTechniqueHeaderDetailCommandModels:
                    prev?.updateStatusTblTestingTechniqueHeaderDetailCommandModels?.map(
                      (item) =>
                        item.id === row.original?.id
                          ? { ...item, testingStatus: value }
                          : item,
                    ),
                }))
              }
            />
          ) : (
            <Text>
              {
                testingStatuss?.find(
                  (item) =>
                    item.value.toString() === row?.original?.testingStatus,
                )?.label
              }
            </Text>
          ),
      },
      {
        accessorKey: "lastUpdateByName",
        header: "Người kiểm tra",
      },
      {
        accessorKey: "noteByEmployee",
        header: "Ghi chú",
        Cell: ({ renderedCellValue, row }) =>
          form ? (
            <TextInput
              placeholder="Nhập ghi chú"
              value={form
                ?.getValues()
                ?.updateStatusTblTestingTechniqueHeaderDetailCommandModels?.find(
                  (d) => d.id === row.original?.id,
                )
                ?.noteByEmployee?.toString()}
              onChange={(e) =>
                form.setValues((prev) => ({
                  ...prev,
                  updateStatusTblTestingTechniqueHeaderDetailCommandModels:
                    prev?.updateStatusTblTestingTechniqueHeaderDetailCommandModels?.map(
                      (item) =>
                        item.id === row.original?.id
                          ? { ...item, noteByEmployee: e.target?.value }
                          : item,
                    ),
                }))
              }
              // disabled={row.original.canUpdate === false}
            />
          ) : (
            <Text>{renderedCellValue}</Text>
          ),
      },
    ],
    [isEditStatus, form, showBhmr],
  );

  const columnsCreate = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue, row }) =>
          row.index !== rowSelect ? (
            <Badge
              radius="sm"
              variant="dot"
              size="lg"
              color={
                renderedCellValue === null || renderedCellValue === ""
                  ? "red"
                  : green.base
              }
            >
              {renderedCellValue === null || renderedCellValue === ""
                ? "Không xác định"
                : renderedCellValue}
            </Badge>
          ) : (
            <Menu keepMounted>
              <Menu.Target>
                <TextInput
                  placeholder="Nhập mã sản phẩm"
                  value={dataEdit?.itemCode}
                  onChange={(e) =>
                    setDataEdit((prev) => ({
                      ...prev,
                      itemCode: e.currentTarget.value,
                    }))
                  }
                />
              </Menu.Target>
              <Menu.Dropdown>
                <Table.ScrollContainer mah={450} minWidth={300} type="native">
                  <Table striped withTableBorder>
                    <Table.Thead>
                      <Table.Tr>
                        <Table.Th>Chọn</Table.Th>
                        <Table.Th>Mã sản phẩm</Table.Th>
                        <Table.Th>Tên sản phẩm</Table.Th>
                      </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                      {dataProductMap?.length > 0 ? (
                        dataProductMap?.map((item) => (
                          <Table.Tr>
                            <Table.Td>
                              <Button
                                onClick={() => {
                                  setDataEdit((prev) => ({
                                    ...prev,
                                    itemCode: item.itemCode,
                                    itemName: item.itemName,
                                    actribute4: item.attribute1,
                                  }));
                                  updateDataListProduct(rowSelect, {
                                    id: 0,
                                    description: "",
                                    itemId: 0,
                                    itemCode: item.itemCode,
                                    itemName: item.itemName,
                                    actribute4: item.attribute1,
                                    actribute5: 1,
                                    serialCode: row.original.serialCode,
                                    notInSystem: true,
                                  });
                                }}
                              >
                                Chọn
                              </Button>
                            </Table.Td>
                            <Table.Td fw={500}>{item.itemCode}</Table.Td>
                            <Table.Td fw={500}>{item.itemName}</Table.Td>
                          </Table.Tr>
                        ))
                      ) : (
                        <Table.Tr>
                          <Table.Td colSpan={3} ta={"center"} fw={500}>
                            Không tìm thấy sản phẩm !
                          </Table.Td>
                        </Table.Tr>
                      )}
                    </Table.Tbody>
                  </Table>
                </Table.ScrollContainer>
              </Menu.Dropdown>
            </Menu>
          ),
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ row }) =>
          row.index !== rowSelect ? (
            <Text fw={500} size="12.5px">
              {row.original.itemName}
            </Text>
          ) : (
            <TextInput
              placeholder="Nhập tên sản phẩm"
              value={dataEdit?.itemName}
              onChange={(e) =>
                setDataEdit((prev) => ({
                  ...prev,
                  itemName: e.currentTarget.value,
                }))
              }
            />
          ),
      },
      {
        accessorKey: "serialCode",
        header: "Số serial",
      },
      {
        accessorKey: "actribute4",
        header: "Đơn vị tính",
        Cell: ({ row }) =>
          row.index !== rowSelect ? (
            <Text fw={500} size="12.5px">
              {row.original.actribute4}
            </Text>
          ) : (
            <TextInput
              placeholder="Nhập đơn vị tính"
              value={dataEdit?.actribute4}
              onChange={(e) =>
                setDataEdit((prev) => ({
                  ...prev,
                  actribute4: e.currentTarget.value,
                }))
              }
            />
          ),
      },
      {
        accessorKey: "actribute5",
        header: "Số lượng",
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        Cell: ({ row }) => (
          <Flex align={"center"} gap={"md"}>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                color="red"
                onClick={() => deleteProduct(row.original.serialCode)}
              >
                <IconTrash stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            {row.original.notInSystem && row.index !== rowSelect ? (
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="light"
                  color="orange"
                  onClick={() => {
                    setDataEdit(row.original);
                    setRowSelect(row.index);
                  }}
                >
                  <IconEdit stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            ) : row.original.notInSystem && row.index === rowSelect ? (
              <Tooltip label="Lưu">
                <ActionIcon
                  variant="light"
                  color="teal"
                  onClick={() => {
                    updateDataListProduct(row.index, dataEdit);
                    setRowSelect(-1);
                  }}
                >
                  <IconCheck stroke={1.5} />
                </ActionIcon>
              </Tooltip>
            ) : (
              <></>
            )}
          </Flex>
        ),
        size: 40,
      },
    ],
    [listProductTest, rowSelect, dataEdit, dataProductMap],
  );

  const updateDataListProduct = (index: number, newValue: dataProduct) => {
    setListProductTest((prev: any) => {
      const newProduct = [...prev];
      newProduct[index] = newValue;
      return newProduct;
    });
  };

  const deleteProduct = (serial: string) => {
    const dataDelete = listProductTest.filter(
      (item: any) => item.serialCode !== serial,
    );

    setListProductTest(dataDelete);
  };

  const handleUpdateAllStatuses = (value: any, rows: any[]) => {
    form?.setValues((prev) => {
      return {
        ...prev,
        updateStatusTblTestingTechniqueHeaderDetailCommandModels:
          prev?.updateStatusTblTestingTechniqueHeaderDetailCommandModels?.map(
            (item) => {
              // Lấy trạng thái ban đầu từ hàng tương ứng
              const row = rows.find((row) => row.original.id === item.id);
              const initialStatus = row?.original.testingStatus;

              // Nếu trạng thái ban đầu là TEST_OK, giữ nguyên
              return {
                ...item,
                testingStatus:
                  initialStatus === "TEST_OK" || initialStatus === "TEST_LOI"
                    ? initialStatus
                    : value,
              };
            },
          ),
      };
    });
  };

  const fetchDataTestDifficultys = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TechnicalTestLevel/get-list?Skip=0&Take=100",
    );

    if (res && res.success) {
      const data = res.data;
      setTestDifficultys(
        data
          ?.filter((i: any) => i.name && i.code)
          ?.map((i: any) => ({
            label: String(i.name),
            value: String(i.code),
          })),
      );
    }
  };

  const fetchDataProduct = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblItem/get-list?Skip=0&Take=20&KeySearch=${dataEdit?.itemCode}`,
    );

    if (res && res.success) {
      const result = res.data;
      setDataProductMap(result);
    }
  };

  const checkSerialSystem = async () => {
    open();
    const serials = listSerial.split(",").map((item) => item.trim());
    const take = listSerial.split(",").map((item) => item.trim()).length;
    let url = `/api/v1/TblSerialNotInSystem/get-list?Skip=0&Take=${take}`;

    if (listSerial.length > 0) {
      url += listSerial.split(",").map((item) => `&Serials=${item}`);
    }
    const res = await repositoryMdm.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const result = res.data?.map((item: any) => ({
        id: 0,
        description: "",
        itemId: 0,
        itemCode: item.itemCode,
        itemName: item.itemName,
        actribute4: item.unitOfMeasure,
        actribute5: 1,
        serialCode: item.serial,
      }));

      setListProductTest((prev: any) => {
        const existingSerials = new Set(
          prev.map((item: any) => item.serialCode),
        );
        const filteredResult = result.filter(
          (item: any) => !existingSerials.has(item.serialCode),
        );
        return [...prev, ...filteredResult];
      });

      setListSerial("");

      const existingSerials = new Set(
        res.data?.map((item: any) => item.serial),
      );

      const missingSerials = serials.filter(
        (serial) => !existingSerials.has(serial),
      );

      if (missingSerials.length > 0) {
        fetchDataSerial(missingSerials);
      } else {
        close();
      }
    } else {
      close();
    }
  };

  const fetchDataSerial = async (listSerial: string[]) => {
    const take = listSerial?.length;
    const res = await repositoryDelivery.get<MessageResponse<any>>(
      `/api/v1/TblInventorySerialOnhand/get-list-serial?Skip=0&Take=${take}&SerialList=${listSerial?.join(
        ",",
      )}&BranchCode=${branchCode}`,
    );

    if (res && res.success) {
      const result = res.data?.map((item: any) => ({
        id: 0,
        description: "",
        itemId: 0,
        itemCode: item.maSp,
        itemName: item.tenSp,
        actribute4: item.dvt,
        actribute5: 1,
        serialCode: item.maBarcode,
      }));

      setListProductTest((prev: any) => {
        const existingSerials = new Set(
          prev.map((item: any) => item.serialCode),
        );
        const filteredResult = result.filter(
          (item: any) => !existingSerials.has(item.serialCode),
        );
        return [...prev, ...filteredResult];
      });

      setListSerial("");

      const existingSerials2 = new Set(
        res.data?.map((item: any) => item.maBarcode),
      );

      const missingSerials = listSerial
        .filter((serial) => !existingSerials2.has(serial))
        ?.map((i) => i?.trim());

      if (missingSerials.length > 0) {
        setListProductTest((prev: any) => {
          const existingSerials3 = new Set(
            prev.map((item: any) => item.serialCode),
          );
          const serialAdd = missingSerials.map((item) => ({
            id: 0,
            description: "",
            itemId: 0,
            itemCode: "",
            itemName: "",
            actribute4: "",
            actribute5: 1,
            serialCode: item,
            notInSystem: true,
          }));
          const filteredResult = serialAdd.filter(
            (item: any) => !existingSerials3.has(item.serialCode),
          );
          return [...prev, ...filteredResult];
        });
      }

      close();
    } else {
      close();
    }
  };

  useEffect(() => {
    let timer: ReturnType<typeof setInterval>;
    if (isCounting && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    } else if (timeLeft === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(timer);
  }, [isCounting, timeLeft]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  useEffect(() => {
    if (dataEdit?.itemCode.length > 3) {
      fetchDataProduct();
    }
  }, [dataEdit?.itemCode]);

  useEffect(() => {
    fetchDataTestDifficultys();
  }, []);

  const table = useMantineReactTable({
    columns: setListProductTest ? columnsCreate : columns,
    data: dataDetail ? dataDetail : listProductTest ? listProductTest : [],
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableRowActions: setListProductTest ? false : true,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    renderToolbarInternalActions: () => <></>,
    renderTopToolbarCustomActions: ({ table }) => {
      const rows = table.getRowModel().rows;
      return (
        <>
          {form !== undefined || testingStatus !== undefined || isAssign ? (
            <>
              <Flex direction={"row"} justify={"start"} gap={"md"}>
                <div>
                  <Select
                    label="Mức độ test của phiếu"
                    placeholder="Chọn mức độ test của phiếu"
                    clearable
                    withAsterisk={form !== undefined}
                    data={testDifficultys}
                    variant={
                      (!form && !isAssign) || isReadOnlyTestDifficulty
                        ? "filled"
                        : "default"
                    }
                    readOnly={(!form && !isAssign) || isReadOnlyTestDifficulty}
                    searchable
                    value={
                      form !== undefined
                        ? form?.getValues()?.testDifficulty
                        : datatestDifficultys
                    }
                    onChange={(value) => {
                      if (isAssign) {
                        isAssign(value ? value : "");
                      } else {
                        form?.setFieldValue("testDifficulty", value);
                      }
                    }}
                  />
                  <span
                    style={{
                      fontSize: "10px",
                      color: "red",
                      marginLeft: "7px",
                      display: `${
                        form !== undefined &&
                        form.getValues()?.testDifficulty == null
                          ? "block"
                          : "none"
                      }`,
                    }}
                  >
                    {form !== undefined &&
                    form.getValues()?.testDifficulty == null
                      ? "Vui lòng chọn mức độ test"
                      : ""}
                  </span>
                </div>
                {form !== undefined ? (
                  <>
                    <Select
                      label="Trạng thái kiểm tra"
                      placeholder="Chọn trạng thái kiểm tra"
                      clearable
                      searchable
                      readOnly={form !== undefined ? false : true}
                      data={testingStatuss}
                      // onChange={(e) => handleUpdateAllStatuses(e)}
                      onChange={(value) => {
                        handleUpdateAllStatuses(value, rows); // Truyền danh sách hàng vào
                      }}
                    />
                  </>
                ) : (
                  <></>
                )}
                {/* {isAdmin === 2 || isAdmin === 1 ? (
                  <NumberInput
                    label="Trừ điểm"
                    placeholder="Nhập số điểm bị trừ"
                    hideControls
                    prefix="- "
                    readOnly={isAdmin === 1}
                  />
                ) : (
                  <></>
                )} */}
              </Flex>
            </>
          ) : null}
          {setListProductTest !== undefined ? (
            <Flex justify={"end"} w={"100%"} gap={"md"}>
              <TextInput
                leftSection={<IconBarcode color="teal" />}
                placeholder='Nhập danh sách mã serial ngăn cách bởi dấu ","'
                value={listSerial}
                onChange={(e) => setListSerial(e.currentTarget.value)}
                w={400}
              />
              <Button
                leftSection={<IconSearch size={14} />}
                color="teal"
                disabled={listSerial.length === 0}
                onClick={() => checkSerialSystem()}
              >
                Tìm kiếm
              </Button>
            </Flex>
          ) : (
            <></>
          )}
        </>
      );
    },
    enableTopToolbar:
      form !== undefined ||
      testingStatus !== undefined ||
      isAssign ||
      setListProductTest !== undefined
        ? true
        : false,
    renderRowActions: ({ row }) => {
      return (
        <>
          {form !== undefined ? (
            <>
              <Flex gap="4">
                {row.original.testingStatus == "TEST_OK" ? (
                  <>
                    <IconEdit
                      color={"orange"} // Thay đổi màu sắc nếu không thể chỉnh sửa
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => setIsEditStatus(!isEditStatus)}
                    ></IconEdit>
                  </>
                ) : (
                  <>
                    <Tooltip label="Chỉnh sửa">
                      <IconEdit
                        color="gray"
                        style={{
                          cursor: "not-allowed",
                        }}
                        onClick={() => {}}
                      ></IconEdit>
                    </Tooltip>
                  </>
                )}
              </Flex>
            </>
          ) : (
            <>
              <Flex gap="4">
                <>
                  <Tooltip label="Chỉnh sửa">
                    <IconEdit
                      color="gray"
                      style={{
                        cursor: "not-allowed",
                      }}
                      onClick={() => {}}
                    ></IconEdit>
                  </Tooltip>
                </>
              </Flex>
            </>
          )}
        </>
      );
    },
    localization: _localization,
    enableRowSelection: false,
    enablePagination: true,
    enableEditing: setListProductTest ? false : true,
    enableBottomToolbar: isDetail,
    enableFilters: false,
    enableColumnActions: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["itemCode"],
        right: ["mrt-row-actions", "action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: {
        maxHeight: !isDetail ? 255 : height,
        minHeight: !isDetail ? 100 : height,
      },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    onPaginationChange: setPagination,
    rowCount: data?.length,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        //  fontWeight: row.getIsSelected() ? "bold" : "normal", //conditional styling
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineTableProps: () => ({
      striped: true,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["10", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 5 }}
        loaderProps={{
          children: (
            <Flex direction={"column"} align="center" gap="xs">
              <Loader type="dots" size={35}></Loader>
              {/* <Title size={15}> Đang upload tài liệu...</Title> */}
              <Title size={15}> Đang xử lý....</Title>
            </Flex>
          ),
        }}
      />
      <MantineReactTable table={table} />
    </Box>
  );
};

export default ListProductDetail;
